/* eslint-disable */
// ---------------------------------------------------------------------------
// Ce qui reste mocké dans le module Serveur.
//
// La carte et les commandes viennent désormais de la base : le catalogue par
// /verifyaccess (partagé avec /menu et /panier), les commandes par
// serveurStoreDB. Ne subsistent ici que deux jeux de données auxquels le
// backend ne donne pas accès.
// ---------------------------------------------------------------------------

/**
 * Tables de salle.
 *
 * Le référentiel réel existe - dbtbfichiers, typetbfichier='table', exposé à la
 * caisse sous la forme { pid, name, code } - mais /verifyaccess ne le remonte
 * pas, et le backend ne doit pas être modifié. On garde donc la même forme que
 * la caisse, pour que le remplacement soit un simple changement de source le
 * jour où l'endpoint existera.
 *
 * Les maquettes mélangeaient « Terrasse 4 », « T-12 » et « TABLE T4 » :
 * on uniformise sur `name`.
 */
export const TABLES = [
    { pid: "t01", name: "Table 1", code: "T01" },
    { pid: "t02", name: "Table 2", code: "T02" },
    { pid: "t03", name: "Table 3", code: "T03" },
    { pid: "t04", name: "Table 4", code: "T04" },
    { pid: "t05", name: "Table 5", code: "T05" },
    { pid: "t06", name: "Table 6", code: "T06" },
    { pid: "te1", name: "Terrasse 1", code: "TE1" },
    { pid: "te2", name: "Terrasse 2", code: "TE2" },
    { pid: "te3", name: "Terrasse 3", code: "TE3" },
    { pid: "sa1", name: "Salon 1", code: "SA1" },
    { pid: "sa2", name: "Salon 2", code: "SA2" },
    { pid: "vip", name: "VIP", code: "VIP" },
];

/**
 * Fond de caisse remis au serveur en début de service.
 * Aucune table ne le porte aujourd'hui ; il devra être saisi par le manager
 * ou déclaré par le serveur à l'ouverture.
 */
export const FOND_DE_CAISSE = 5000;

let _lineId = 0;
/** Identifiant de ligne, local et éphémère : il ne sert qu'au rendu et au regroupement. */
export function prochainLineId() { return ++_lineId; }
